import React, { useState } from 'react';

import { Box, Dialog, DialogContent, Paper, Tabs } from '@mui/material';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import {
  Close as CloseIcon,
  Email as EmailIcon,
  Event as EventIcon,
  Home as HomeIcon,
  Visibility as VisibilityIcon
} from '@mui/icons-material';
import Tab from '@mui/material/Tab';
import IconButton from '@mui/material/IconButton';
import { closeModal } from './modalReducer';
import { useDispatch } from 'react-redux';
import NextInvoiceDetails from '../../views/Invoice/NextInvoiceDetails';
import { formatNumberToCurrency } from '../../helpers/utils';
import InvoiceRecipients from '../../views/Invoice/InvoiceRecipients';
import TenantInvoices from '../../views/Invoice/TenantInvoices';

const InvoiceManageModal = ({ tenant }) => {
  const dispatch = useDispatch();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  return (
    <Dialog
      open
      onClose={handleCloseModal}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 3, backgroundColor: '#f9fafb' }
      }}
    >
      <Box p={3} bgcolor="white" borderBottom="1px solid #eee">
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box display="flex" gap={2}>
            <Avatar
              sx={{
                bgcolor: '#FFEBEE',
                color: '#D32F2F',
                width: 56,
                height: 56,
                fontSize: '1.5rem'
              }}
            >
              {getInitials(tenant.companyname)}
            </Avatar>
            <Box>
              <Typography variant="h6" fontWeight="bold">
                {tenant.tradingname || tenant.companyname}
              </Typography>
              <Box display="flex" alignItems="center" gap={0.5} color="text.secondary" mt={0.5}>
                <HomeIcon fontSize="small" />
                <Typography variant="body2">{tenant.assetname}</Typography>
              </Box>
            </Box>
          </Box>
          <IconButton onClick={handleCloseModal}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* --- Top KPIs (Using Grid 2) --- */}
        <Box
          sx={{
            marginTop: '20px',
            display: 'flex',
            flexDirection: 'row',
            flexGrow: 1,
            gap: '20px'
          }}
        >
          <Box>
            <KpiCard
              label="Monthly Rent"
              value={formatNumberToCurrency(tenant.nextinvoicepaymentvalue)}
            />
          </Box>
          <Box>
            <KpiCard label="Total Paid" value={'Todo'} color="#2e7d32" />
          </Box>
          <Box>
            <KpiCard label="Outstanding" value={'TODO'} color="#c62828" />
          </Box>
        </Box>
      </Box>

      {/* --- Tabs --- */}
      <Box bgcolor="white" px={3}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
        >
          <Tab label="Overview" icon={<VisibilityIcon fontSize="small" />} iconPosition="start" />
          <Tab label="Recipients" icon={<EmailIcon fontSize="small" />} iconPosition="start" />
          <Tab label="Schedule" icon={<EventIcon fontSize="small" />} iconPosition="start" />
        </Tabs>
      </Box>

      <DialogContent>
        {tabValue === 0 && <NextInvoiceDetails tenant={tenant} />}
        {tabValue === 1 && <InvoiceRecipients tenantId={tenant.id} />}
        {tabValue === 2 && <TenantInvoices tenantId={tenant.id} />}
      </DialogContent>
    </Dialog>
  );
};

const KpiCard = ({ label, value, color = '#000' }) => (
  <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, height: '100%' }}>
    <Typography variant="caption" color="textSecondary" display="block" gutterBottom>
      {label}
    </Typography>
    <Typography variant="h6" style={{ color: color, fontWeight: 'bold' }}>
      {value}
    </Typography>
  </Paper>
);

const getInitials = (name) => {
  return name ? name.substring(0, 1).toUpperCase() : 'T';
};


export default InvoiceManageModal;